// Small inline icons used by Home v2 that aren't in @common/assets/svg.
// Stroke-based, follow the same 1.75 stroke convention as the design set.
// Cross-platform (react-native-svg) — shared by mobile-web home + extension
// popup/tab dashboard.
import React from 'react'
import Svg, { Circle, Path, SvgProps } from 'react-native-svg'

type IconProps = SvgProps & { size?: number; color?: string }

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none' as const
})

export const EyeIcon: React.FC<IconProps> = ({ size = 20, color = '#fff', ...rest }) => (
  <Svg {...base(size)} {...rest}>
    <Path
      d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Circle cx={12} cy={12} r={3} stroke={color} strokeWidth={1.75} />
  </Svg>
)

export const EyeOffIcon: React.FC<IconProps> = ({ size = 20, color = '#fff', ...rest }) => (
  <Svg {...base(size)} {...rest}>
    <Path
      d="M3 3l18 18M10.6 10.7a3 3 0 0 0 4.2 4.2M9.4 5.2A10 10 0 0 1 12 5c6.5 0 10 7 10 7a18 18 0 0 1-3.2 4M6.3 7.3A18 18 0 0 0 2 12s3.5 7 10 7a10 10 0 0 0 2.6-.3"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

export const PlusIcon: React.FC<IconProps> = ({ size = 16, color = '#fff', ...rest }) => (
  <Svg {...base(size)} {...rest}>
    <Path d="M12 5v14M5 12h14" stroke={color} strokeWidth={1.75} strokeLinecap="round" />
  </Svg>
)

export const ChevronDownIcon: React.FC<IconProps> = ({ size = 16, color = '#fff', ...rest }) => (
  <Svg {...base(size)} {...rest}>
    <Path
      d="m5 9 7 7 7-7"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

// Double-chevron — the sidebar collapse/expand toggle. Points left («) to fold
// the sidebar to its icon-only rail; flip with `direction="right"` (»») to expand.
export const ChevronsIcon: React.FC<IconProps & { direction?: 'left' | 'right' }> = ({
  size = 18,
  color = '#fff',
  direction = 'left',
  ...rest
}) => (
  <Svg {...base(size)} {...rest}>
    <Path
      d={direction === 'left' ? 'm11 17-5-5 5-5M18 17l-5-5 5-5' : 'm13 17 5-5-5-5M6 17l5-5-5-5'}
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

// Up/down chevron pair — signals a switcher/selector (used by the sidebar
// account chip to open the account picker).
export const CaretUpDownIcon: React.FC<IconProps> = ({ size = 16, color = '#fff', ...rest }) => (
  <Svg {...base(size)} {...rest}>
    <Path
      d="m8 9 4-4 4 4M8 15l4 4 4-4"
      stroke={color}
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)
